module.exports = __webpack_public_path__ + "img/5_105.287dcceb.png";